import server from "@/backend";

const preUrl = "/tracking"

const telemetry = {
  lastPositions: function(filter) {
    return server.post(preUrl + "/last_positions", filter);
  },
  devices: function(filter) {
    return server.post(preUrl + "/devices", filter);
  },
  poles: function(filter) {
    return server.post(preUrl + "/poles", filter);
  },
  pole_telemetry: function(device, filter) {
    return server.post(preUrl + "/pole_telemetry/" + device, filter);
  },
  tags: function(filter) {
    return server.post(preUrl + "/tags", filter);
  },
  zoneCount: function(filter) {
    return server.post(preUrl + "/zone_count", filter);
  },
  zoneCountBucket: function(category, filter) {
    return category ? server.post(preUrl + "/category_count_bucket", filter) : server.post(preUrl + "/zone_count_bucket", filter);
  },
  devicePositions: function(device, filter) {
    if(device !== undefined && device !== null) {
      return server.post(preUrl + "/device_positions/" + device, filter);
    }
  },
  occupancy: function(filter) {
    return server.post(preUrl + "/occupancy/", filter);
  },
  deviceInfo: function(device) {
    if(device !== undefined && device !== null) {
      return server.post(preUrl + "/device_info/" + device, {});
    }
  },
  dailyDeviceActivity: function(device, filter) {
    if(device !== undefined && device !== null) {
      return server.post(preUrl + "/daily_device_activity/" + device, filter);
    }
  },
  // Groups
  groups: function(filter) {
    return server.post(preUrl + "/groups", filter);
  },
  updateGroup: function(group) {
    return server.post(preUrl + "/group", group);
  },
  deleteGroup: function(group) {
    if(group !== undefined && group !== null) {
      return server.delete(preUrl + "/group/" + group);
    }
  },

  // Buildings
  buildings: function(filter) {
    return server.post(preUrl + "/buildings", filter);
  },
  updateBuilding: function(building) {
    return server.post(preUrl + "/building", building);
  },
  deleteBuilding: function(building) {
    if(building !== undefined && building !== null) {
      return server.delete(preUrl + "/building/" + building);
    }
  },
  exportDevice: function(device) {
    return server.post(preUrl + "/export_device/" + (device ? device : ''));
  },

  // Zones
  zones: function(filter) {
    return server.post(preUrl + "/zones", filter);
  },
  updateZone: function(zone) {
    if(zone !== undefined && zone !== null) {
      return server.post(preUrl + "/zone", zone);
    }
  },
  updateDevice: function(device) {
    if(device !== undefined && device !== null) {
      return server.post(preUrl + "/device", device);
    }
  },
  deleteZone: function(zone) {
    if(zone !== undefined && zone !== null) {
      return server.delete(preUrl + "/zone/"+zone);
    }
  }
}

const auth = {
  lastpositions: function() {
    return server.post(preUrl + "/last_positions");
  },
  login: function(email, password) {
    if (email && password) {
      return server.post(`auth/login`, { email: email, password: password });
    }
  },
  change: function(oldPassword, newPassword) {
    if (oldPassword !== "" && newPassword !== "") {
      return server.post(`auth/change`, {
        oldPassword: oldPassword,
        newPassword: newPassword
      });
    }
  },
  logout: function() {
    localStorage.token = "";
    localStorage.refreshToken = "";
    if (this.$store) {
      this.$store.dispatch("resetStore");
    }
  },
  renew: function(refreshToken) {
    if (refreshToken) {
      return server.post("/auth/refresh", { token: refreshToken });
    }
  },
  register: function(data) {
    return server.post("/auth/register", data);
  },
  reset: function(data) {
    return server.post("/auth/reset", data);
  }
}

export { auth }
export { telemetry }
